import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=7f2ad659&scoped=true"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2ad659",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2ad659')) {
      api.createRecord('7f2ad659', component.options)
    } else {
      api.reload('7f2ad659', component.options)
    }
    module.hot.accept("./photo.vue?vue&type=template&id=7f2ad659&scoped=true", function () {
      api.rerender('7f2ad659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/photo.vue"
export default component.exports